import React from 'react';

const VideoPreview = ({ videoUrl }: { videoUrl: string | null }) => {
  if (!videoUrl) return null;

  return (
    <div className="my-4">
      {/* eslint-disable-next-line jsx-a11y/media-has-caption -- user-recorded response video; no captioning pipeline exists yet for dynamically generated content */}
      <video controls className="w-full max-h-[300px] rounded-lg" src={videoUrl} data-testid="video-preview" />
    </div>
  );
};

export default VideoPreview;
